import { SocialExportRudoFolderDto } from '@mi-front/api-v2';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { rudoMessages } from '../rudo-messages';

type Props = {
  folders: SocialExportRudoFolderDto[];
  isLoading: boolean;
  required?: boolean;
};

/**
 * Searchable autocomplete for selecting a single Rudo folder (supports large lists).
 * Form field `folderId` stores the folder id via matchId.
 */
export function RudoFoldersAutocomplete({ folders, isLoading, required = false }: Props) {
  const { control } = useFormContext();
  const { $t } = useIntl();

  return (
    <AutocompleteElement
      name="folderId"
      control={control}
      options={folders}
      matchId
      loading={isLoading}
      required={required}
      label={$t(rudoMessages.folderLabel)}
      textFieldProps={{
        fullWidth: true,
        helperText: $t(rudoMessages.folderHelper),
      }}
      autocompleteProps={{
        fullWidth: true,
        getOptionLabel: (option: SocialExportRudoFolderDto | string) => {
          if (typeof option === 'string') return option;
          return option.name;
        },
        isOptionEqualToValue: (
          option: SocialExportRudoFolderDto,
          value: SocialExportRudoFolderDto | number | null,
        ) => {
          if (value == null) return false;
          if (typeof value === 'number') return option.id === value;
          return option.id === value.id;
        },
        noOptionsText: $t(rudoMessages.folderNoOptions),
      }}
    />
  );
}
